import { NgModule } from "@angular/core";
import { SafeUrlPipe } from 'src/app/utils/pipes/safe-url.pipe';

@NgModule({
    declarations: [
        SafeUrlPipe
    ],
    exports: [
        SafeUrlPipe
    ],
})
export class SafeUrlModule {}